import React from 'react';
import { getGeniallyEmbedUrl } from '../../../../utils/promotionUtils/getGeniallyEmbedUrl';
import classes from '../ContentPromotionPopup.module.css';

const GeniallyContent = ({ url, title }) => {
    const embedUrl = getGeniallyEmbedUrl(url);

    return embedUrl &&
        <iframe
            src={embedUrl}
            className={classes.Renderer}
            title={title}
            frameBorder="0"
            allow="fullscreen"
            allowFullScreen
        />;
};

export default GeniallyContent;
